<template>
   <div class="parents-info">
          <div class="parents-info__edit text-right">
              <h3 class=" font-size-16 primary-color font-family-Semibold cursor-pointer" @click="editInfo">Chỉnh sửa</h3>
          </div>
          <div class="parents-info__all">
              <div class="row">
                <div class="name col-lg-6 col-md-6 col-12">
                    <label class="secondary-color-txt font-sanpro-semibold" for="">Tên phụ huynh</label><br>
                    <input type="text" placeholder="Nguyễn Văn B" v-model="getBaseInfo.parentName"   :class="{'pointer-events': displayEdit}">
                </div>
                <div class="name col-lg-6 col-md-6 col-12"></div>
                <div class="email col-lg-6 col-md-6 col-12">
                    <label class="secondary-color-txt font-sanpro-semibold" for="" >Email</label><br>
                    <input type="text" placeholder="nguyenvanan@gmail.com"  v-model="getBaseInfo.parentEmail"  :class="{'pointer-events': displayEdit}">
                </div>
                <div class="phone col-lg-6 col-md-6 col-12">
                    <label class="secondary-color-txt font-sanpro-semibold" for="">Số điện thoại</label><br>
                    <input type="text" placeholder="Số điện thoại của bạn"  v-model="getBaseInfo.parentPhoneNumber"   :class="{'pointer-events': displayEdit}">
                </div>
              </div>
            <div class="d-flex justify-content-end" v-if="!displayEdit">
                <button type="button" class="btn close-button font-sanpro-bold primary-color font-size-16" data-dismiss="modal" >  Huỷ  </button>
                <button @click="submitInfo" type="submit" class="btn btn-main border-rd-20 font-size-16 font-sanpro-semibold p-b p-t ">Hoàn thành</button>
            </div>
          </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { STORE_KEY } from "../../_store/constants";
export default {
    name:"InfoParents",
      data() {
    return {
        displayEdit:true,
        disabled: true,
    };
  },
  computed: {
    ...mapGetters({
      getBaseInfo: STORE_KEY + "/getBaseInfo"
    })
  },
  methods:{
    ...mapActions(`${STORE_KEY}`, ["actionGetBaseInfo","actionUpdateParentInfo"]),
    ...mapActions(`common`, ["setLoading"]),
    submitInfo(){
    this.actionUpdateParentInfo({parentName: this.getBaseInfo.parentName,parentPhoneNumber:this.getBaseInfo.parentPhoneNumber})
    .then(res => {
        if (res.status === "success") {
        this.actionGetBaseInfo();
        this.displayEdit = true;
        this.disabled = true;  
        this.$toast.success("Thêm thành công");
        }
    });
    },
    editInfo(){
        this.displayEdit = false;
        this.disabled = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.pointer-events{
  pointer-events: none;
  color: #40505E;
}
.btn-primary {
    height: 30px;
    padding-top: 0px;
    padding-bottom: 0px;
    border-radius: 20px;
}
.parents-info{
    &__all{
        .name, .email, .phone{
            margin-bottom: 15px;
        }
        label{
            margin-bottom: 5px;
        }
        input{
            background-color: #F3F6FB;
            border: 0;
            border-radius: 20px;
            padding-left: 15px;
            height: 32px;
            line-height: 32px;
            width: 100%;
            color: #40505E;
        }
    }
}

</style>